/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modality_EnduranceInputs */

const en_us2_modality_endurance = /** @type {(inputs: Modality_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running, cycling, swimming`)
};

const pt_br2_modality_endurance = /** @type {(inputs: Modality_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrida, ciclismo, natação`)
};

const es_419_modality_endurance = /** @type {(inputs: Modality_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correr, ciclismo, natación`)
};

const pt_pt2_modality_endurance = /** @type {(inputs: Modality_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrida, ciclismo, natação`)
};

const fr_fr2_modality_endurance = /** @type {(inputs: Modality_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course, vélo, natation`)
};

const de_de2_modality_endurance = /** @type {(inputs: Modality_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufen, Radfahren, Schwimmen`)
};

const it_it2_modality_endurance = /** @type {(inputs: Modality_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corsa, ciclismo, nuoto`)
};

/**
* | output |
* | --- |
* | "Running, cycling, swimming" |
*
* @param {Modality_EnduranceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const modality_endurance = /** @type {((inputs?: Modality_EnduranceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modality_EnduranceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_modality_endurance(inputs)
	if (locale === "es-419") return es_419_modality_endurance(inputs)
	if (locale === "pt-PT") return pt_pt2_modality_endurance(inputs)
	if (locale === "fr-FR") return fr_fr2_modality_endurance(inputs)
	if (locale === "de-DE") return de_de2_modality_endurance(inputs)
	if (locale === "it-IT") return it_it2_modality_endurance(inputs)
	return en_us2_modality_endurance(inputs)
});
export { modality_endurance as "modality.endurance" }